<mat-toolbar color="accent">
  <span>Email Referral Letter to Patient</span>
</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    @if (!hasPatientEmail()) {
      <pt-alert
        alert="No email address configured for the patient. Please update the patient's contact details before sending."
      >
        <button mat-button color="primary" mat-dialog-close>Cancel</button>
      </pt-alert>
    }

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>To</mat-label>
      <input matInput type="email" [value]="patientEmail()" [disabled]="true" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Subject</mat-label>
      <input
        matInput
        type="text"
        placeholder="Email subject"
        [formControl]="form.controls.subject"
      />
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="w-full"
      subscriptSizing="dynamic"
    >
      <mat-label>Message</mat-label>
      <pr-content-editor
        class="w-full"
        placeholder="Compose your email message to the patient..."
        format="email"
        [menuEnabled]="true"
        [menuItems]="menuItems"
        [formControl]="form.controls.emailBody"
      />
    </mat-form-field>

    <pr-information-box>
      The patient will receive an email with your message above and the referral
      letter attached as a PDF.
    </pr-information-box>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!canSend()"
      (click)="send()"
    >
      <mat-icon>send</mat-icon>
      Send Email
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
